import React from "react";

export default function MainAddictionRibon(props) {
  return (
    <div
      className="ribon-primary-addiction-v2"
      onClick={props.onClick}
      style={{ cursor: "pointer" }}
    >
      {props.mainAddiction
        ? props.mainAddiction === "Other"
          ? "Primary addiction: " + props.addictionOther
          : "Primary addiction: " + props.mainAddiction
        : "No primary addiction recorded"}
    </div>
  );
}
